"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
// We don't expose the option to change voicemail or fax toast, and we don't want to change the legacy settings, either.
// This mask is used in preserving these settings
var NOTIFICATION_MASK = 4 /* VoiceMailToast */ | 8 /* FaxToast */;
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveMessageOption')(function saveMessageOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceObject, newNotifySetting;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceObject = {};
                    if (optionState.soundNotify !== null || optionState.emailToastNotify !== null) {
                        newNotifySetting = userOptions.NewItemNotify & NOTIFICATION_MASK;
                        newNotifySetting |=
                            optionState.soundNotify === null
                                ? userOptions.NewItemNotify & 1 /* Sound */
                                : optionState.soundNotify ? 1 /* Sound */ : 0 /* None */;
                        newNotifySetting |=
                            optionState.emailToastNotify === null
                                ? userOptions.NewItemNotify & 2 /* EMailToast */
                                : optionState.emailToastNotify
                                    ? 2 /* EMailToast */
                                    : 0 /* None */;
                        userOptions.NewItemNotify = newNotifySetting;
                        serviceObject.NewItemNotification = newNotifySetting;
                    }
                    if (optionState.emptyDeletedItemsOnLogOut !== null) {
                        userOptions.EmptyDeletedItemsOnLogoff = optionState.emptyDeletedItemsOnLogOut;
                        serviceObject.EmptyDeletedItemsOnLogoff = optionState.emptyDeletedItemsOnLogOut;
                    }
                    return [4 /*yield*/, owa_options_core_1.setMailboxMessageConfiguration(serviceObject)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveMessageOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-option/lib/actions/saveMessageOption.js
// module id = 5054
// module chunks = 2